(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buddies-collection-review"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-buddies-review]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const $ = selector => root.querySelector(selector);
  const $$ = selector => [...root.querySelectorAll(selector)];
  const decoder = document.createElement('textarea');
  const decode = text => { decoder.innerHTML = String(text); return decoder.value; };
  const copy = Object.fromEntries(Object.entries(JSON.parse($('[data-br-copy]').textContent)).map(([key, value]) => [key, decode(value)]));
  const message = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll('{' + name + '}', String(value)), copy[key] || key);
  const CONFIG = {"for-your-pooch":{"chips":"style","groups":["kind","price","feature","material","colour"]},"beds":{"chips":[["Caves & nests","cave|nest|igloo|sleeping bag|teepee|playhouse|\\bpod\\b"],["Hammocks","hammock"],["Tunnels","tunnel"],["Round beds","calming cat bed|\\bround\\b|donut"],["Blankets","blanket"]],"groups":["price","colour"]},"dog-harnesses":{"chips":[["Harnesses","harness","tags"],["Leashes & seat belts","leash|seat belt"],["Personalised","personali[sz]|custom|engrav|harness tags"],["Travel & extras","poop|trunk|suv|life jacket|car leash|seat belt"]],"groups":["price","size","colour"]},"bowls-feeders-dog":{"chips":[["Bowls","bowl"],["Auto feeders & fountains","automatic|fountain|kibble"],["Water bottles","bottle"],["Puzzle feeders","puzzle|slow feeder|treat launcher"]],"groups":["price","colour"]},"cat-bowls-and-feeders":{"chips":[["Bowls","bowl"],["Fountains & feeders","fountain|feeder|dispenser"]],"groups":["price","colour"]},"cat-fashion":{"chips":[["Clothing","sweater|hoodie|jacket|coat|shirt"],["Collars","collar"]],"groups":["price","colour"]},"cat-grooming-1":{"chips":[["Brushes & combs","brush|comb|glove"],["Nail care","nail"],["Flea & tick","flea|tick|pest"],["Bath & care","towel|hammock|balm|dryer|bath"]],"groups":["price","colour"]},"cat-harness":{"chips":[["Collars","collar"],["Harness","harness"],["Engraved","engrav"]],"groups":["price","colour"]},"cat-toys":{"chips":[["Interactive","interactive|spinning|suction|challenge|windmill|tower|balance|jumping|rolling|bounce"],["Scratchers","scratch"],["Tunnels & play","tunnel|teepee|playhouse|cat tree"],["Plush","plush|cuddle"],["Treat toys","treat"]],"groups":["price","colour"]},"customisable-products":{"chips":[["Collars","collar","leash"],["Collar & leash sets","leash"],["Harnesses","harness"]],"groups":["pet","price","colour"]},"dog-fashion":{"chips":[["Coats & jackets","coat|jacket","raincoat|life jacket"],["Raincoats","raincoat"],["Hoodies & shirts","hoodie|shirt"],["Boots","boot|shoe"],["Cooling","cooling"],["Life jackets","life jacket"],["Robes","robe"]],"groups":["price","size","colour","season"]},"dog-toys":{"chips":[["Puzzle & treat","puzzle|treat|snuffle|\\biq\\b|launcher|balance"],["Chew & tug","chew|molar|rope|pull toy|tug"],["Plush","plush|duckie|dino"],["Balls","\\bball\\b|football"]],"groups":["price","colour"]},"doggrooming":{"chips":[["Brushes","brush|comb|glove|deshedding","fingerbrush"],["Nail care","nail"],["Bath & drying","bath|towel|robe|dryer|paw cleaner|hammock"],["Flea & tick","flea|tick|pest"],["Dental","dental|fingerbrush|molar"]],"groups":["price","colour"]},"gift-cards-1":{"bare":true},"kitten-1":{"chips":[["Beds","\\bbed\\b|cave|nest|igloo",null,"pet bed"],["Toys","toy\\b|cat tree|cuddle",null,"toys"],["Grooming","brush|nail|groom",null,"grooming"],["Collars & harnesses","collar|harness"],["Bowls","bowl|fountain|feeder"]],"groups":["price"]},"new-products":{"chips":[["Beds","\\bbed\\b|hammock|cave|nest|\\brug\\b","carrier","pet bed"],["Collars & leashes","collar|leash|harness"],["Toys","\\btoy\\b|snuffle|plushie",null,"toys"],["Carriers","carrier|backpack",null,"carriers"],["Grooming","groom|brush|cleaner|poop",null,"grooming"],["Fashion","hoodie|sweater|jacket|coat",null,"fashion|pet jacket"],["Bowls","bowl|feeder|fountain|water bottle",null,"bottles and feeders"]],"groups":["pet","price"]},"our-best-sellers":{"chips":[["Beds","\\bbed\\b|blanket|cover|protector",null,"pet bed"],["Collars & leashes","collar|leash|harness"],["Toys","\\btoy\\b|ball",null,"toys"],["Fashion","boots|shoes|raincoat|life jacket|jacket",null,"fashion|pet jacket"],["Bowls","bowl|feeder|fountain|water bottle",null,"bottles and feeders"],["Grooming","groom|brush|clipper",null,"grooming"],["Carriers","carrier|backpack|stairs",null,"carriers"]],"groups":["pet","price"]},"puppy-1":{"chips":[["Beds","\\bbed\\b|blanket|cave|cover",null,"pet bed"],["Collars","collar|harness|leash"],["Toys","\\btoy\\b|plushie|snuffle|puzzle|ball",null,"toys|dog toys"],["Grooming","groom|brush|nail|robe|poop",null,"grooming"],["Bowls","bowl|feeder|fountain|water bottle",null,"bottles and feeders"],["Travel","carrier|backpack|car seat|travel|car leash|outdoor pet bed",null,"carriers"],["Training","pee pad|absorbent pad|playpen|training|stairs"]],"groups":["price"]},"dog-collars":{"chips":[["Collars","collar","leash"],["Leashes","leash","set"],["Collar & leash sets","collar and leash sets?"],["Personalised / engraved","personali[sz]|engrav|custom"],["Tags & accessories","airtag|\\bled\\b|charm|\\btags?\\b"]],"groups":["price","colour"],"minChip":2},"carriers":{"chips":[["Backpacks","backpack"],["Shoulder & tote bags","shoulder|sling|tote"],["Car seats & travel","car seat|car barrier|seat pad|suv|trunk"],["Airline carriers","airline"]],"groups":["pet","price","colour"],"minChip":2},"calming-beds":{"chips":"style","styleKeys":["boucle","calming","sofa","outdoor","cave"],"groups":["price","colour"],"minChip":2,"minChips":2},"orthopedic-beds":{"chips":"style","styleKeys":["boucle","calming","sofa","outdoor","cave"],"groups":["price","colour"],"minChip":2,"minChips":2},"mattress-beds":{"chips":"style","styleKeys":["boucle","calming","sofa","outdoor","cave"],"groups":["price","colour"],"minChip":2,"minChips":2},"bolster-beds":{"chips":"style","styleKeys":["boucle","calming","sofa","outdoor","cave"],"groups":["price","colour"],"minChip":2,"minChips":2},"nesting-beds":{"chips":"style","styleKeys":["boucle","calming","sofa","outdoor","cave"],"groups":["price","colour"],"minChip":2,"minChips":2},"large-xl-beds":{"chips":"style","styleKeys":["boucle","calming","sofa","outdoor","cave"],"groups":["price","colour"],"minChip":2,"minChips":2}};
  const handle = root.dataset.handle;
  const conf = CONFIG[handle] || { chips: 'auto', groups: ['pet', 'price', 'colour'] };
  const hasSidebar = root.hasAttribute('data-sidebar');
  const petHandles = (root.dataset.petHandles || '').split(',').map(item => item.trim().toLowerCase()).filter(Boolean);
  const currency = root.dataset.currency;
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'narrowSymbol', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(value) + ' ' + currency;

  const PATTERN = /\b(?:rainbow|multi|camo|camouflage|plaid|stripes?|flowers?|floral|stars?|print|grid|chessboard|checker|checkerboard|kitties|dragon|daisy|pineapple|coconut|ice cream|elephant|cupcake|clouds?|waves|bears|cats|series|fivestar|alpaca|blue kitten)\b/i;
  const FAMILIES = [
    ['pink', 'Pink', 'rose|cherry blossoms?|blush|fuchsia|magenta|pink'],
    ['purple', 'Purple', 'lilac|lavender|violet|purple|plum'],
    ['red', 'Red', 'burgundy|wine|scarlet|maroon|cherry|red'],
    ['blue', 'Blue', 'navy|indigo|sapphire|turquoise|turqoise|teal|aqua|denim|midnight|blue'],
    ['green', 'Green', 'olive|emerald|mint|lime|spearmint|army|military|avocado|sage|green'],
    ['orange', 'Orange & yellow', 'orange|yellow|lemon|mustard|gold|golden|peach|apricot'],
    ['beige', 'Beige & brown', 'beige|brown|coffee|khaki|kaki|tan|camel|latte|espresso|chocolate|mocha|sand'],
    ['grey', 'Grey', 'grey|gray|slate|ash|silver|charcoal'],
    ['white', 'White & cream', 'white|cream|ivory|milk|porcelain'],
    ['black', 'Black', 'black']
  ].map(([key, label, words]) => ({ key, label, re: new RegExp('\\b(?:' + words + ')\\b', 'gi') }));
  const MULTI = { key: 'multi', label: 'Multi/patterned' };
  const familyOf = raw => {
    const value = String(raw || '').trim();
    if (!value || /^(default title|default-variant|random)$/i.test(value)) return null;
    if (PATTERN.test(value)) return MULTI.key;
    let words = 0, first = null;
    FAMILIES.forEach(family => { const hits = value.match(family.re); if (hits) { words += hits.length; if (!first) first = family.key; } });
    if (words >= 3) return MULTI.key;
    return first;
  };
  const SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
  const sizeOf = raw => {
    let token = String(raw || '').trim().split(/[\s(:/|,]/)[0].toUpperCase();
    token = { XXL: '2XL', XXXL: '3XL', XXXXL: '4XL', XXXXXL: '5XL' }[token] || token;
    return SIZE_ORDER.includes(token) ? token : null;
  };
  const SEASONS = [['cold', /winter|coat|jacket|hoodie|sweater|fluffy|fleece/i, /raincoat|life jacket/i], ['rain', /rain|waterproof/i, null], ['warm', /cooling|summer|aloha|shirt|life jacket|breathable/i, null]];
  const petsOf = (title, type, tags) => {
    const pets = new Set();
    if (tags.some(tag => ['dog', 'dogs', 'puppy'].includes(tag))) pets.add('dog');
    if (tags.some(tag => ['cat', 'cats', 'kitten'].includes(tag))) pets.add('cat');
    const text = (title + ' ' + type).toLowerCase();
    if (/\b(dog|dogs|puppy|pooch|canine|doggo)\b/.test(text)) pets.add('dog');
    if (/\b(cat|cats|kitten|kitty)\b/.test(text)) pets.add('cat');
    return [...pets];
  };
  const optionValues = option => (option?.values || []).map(value => typeof value === 'string' ? value : value?.name).filter(Boolean);
  const cards = $$('[data-product-card]').map(element => {
    let options = [];
    try { options = JSON.parse(element.querySelector('[data-product-options]').textContent) || []; } catch (error) { options = []; }
    const colourOption = options.find(option => /colou?r/i.test(option.name));
    const sizeOption = options.find(option => /size|sizing/i.test(option.name));
    const title = element.dataset.title || '';
    const type = element.dataset.type || '';
    const tags = (element.dataset.tags || '').split('|').map(tag => tag.trim()).filter(Boolean);
    const sizes = [...new Set(optionValues(sizeOption).map(sizeOf).filter(Boolean))];
    return {
      element, title, type, handle: element.dataset.handle, kind: element.dataset.kind, style: element.dataset.style, price: Number(element.dataset.price) / 100, sizes, chips: [],
      groups: {
        colour: [...new Set(optionValues(colourOption).map(familyOf).filter(Boolean))],
        size: sizes,
        pet: petsOf(title, type, tags),
        season: SEASONS.filter(([, re, not]) => re.test(title) && !(not && not.test(title))).map(([key]) => key),
        feature: (element.dataset.feature || '').split(',').filter(Boolean),
        material: element.dataset.material ? [element.dataset.material] : []
      }
    };
  });
  const groupLabels = {
    colour: value => (FAMILIES.find(family => family.key === value) || MULTI).label,
    size: value => value,
    pet: value => copy['pet_' + value] || value,
    season: value => copy['season_' + value] || value,
    feature: value => copy['feat_' + value] || value,
    material: value => copy['mat_' + value] || value
  };
  const groupOrder = {
    colour: ['black', 'grey', 'white', 'beige', 'pink', 'red', 'orange', 'green', 'blue', 'purple', 'multi'],
    size: SIZE_ORDER,
    pet: ['dog', 'cat'],
    season: ['cold', 'rain', 'warm'],
    feature: ['wash', 'machine_product', 'convert', 'fold'],
    material: ['boucle', 'fur', 'velvet', 'fleece']
  };

  const slug = text => text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const TYPE_GROUPS = { 'pet bed': 'Beds', 'pet beds': 'Beds', 'cat tunnel': 'Beds', 'toys': 'Toys', 'dog toys': 'Toys', 'cat toys': 'Toys', 'pet collars & harnesses': 'Collars & harnesses', 'harness': 'Collars & harnesses', 'harnesses': 'Collars & harnesses', 'collars': 'Collars & harnesses', 'fashion': 'Fashion', 'pet jacket': 'Fashion', 'bottles and feeders': 'Bowls & feeders', 'carriers': 'Carriers', 'grooming': 'Grooming', 'pet stairs': 'Stairs & pens', 'playpen': 'Stairs & pens', 'puppy items': 'Puppy essentials', 'cat accessories': 'Accessories', 'seasonal': 'Seasonal' };
  const typeGroup = type => { const key = type.trim().toLowerCase(); if (!key) return null; return TYPE_GROUPS[key] || type.trim().replace(/^./, letter => letter.toUpperCase()); };
  const autoChips = () => {
    const counts = {};
    cards.forEach(card => { const label = typeGroup(card.type); if (label) counts[label] = (counts[label] || 0) + 1; });
    const labels = Object.keys(counts).filter(label => counts[label] >= 2).sort((a, b) => counts[b] - counts[a] || a.localeCompare(b)).slice(0, 8);
    if (labels.length < 2) return [];
    return labels.map(label => ({ key: slug(label), label, test: card => typeGroup(card.type) === label }));
  };
  const chipDefs = conf.chips === 'auto' ? autoChips() : conf.chips === 'style'
    ? (conf.styleKeys || ['boucle', 'calming', 'sofa', 'outdoor', 'cave', 'cover']).map(key => ({ key, label: copy['style_' + key], test: card => card.style === key }))
    : (conf.chips || []).map(([label, re, not, type]) => {
      const match = new RegExp(re, 'i'), exclude = not ? new RegExp(not, 'i') : null, typeMatch = type ? new RegExp(type, 'i') : null;
      return { key: slug(label), label, test: card => (match.test(card.title) || Boolean(typeMatch && typeMatch.test(card.type))) && !(exclude && exclude.test(card.title)) };
    });
  cards.forEach(card => { card.chips = chipDefs.filter(def => def.test(card)).map(def => def.key); });
  const minChip = conf.minChip || 1;
  let activeChips = chipDefs.filter(def => cards.filter(card => card.chips.includes(def.key)).length >= minChip);
  if (cards.length < 5 || activeChips.length < (conf.minChips || 1)) activeChips = [];
  const chipBar = $('[data-chip-bar]');
  if (chipBar && activeChips.length) {
    [{ key: '', label: conf.chips === 'style' ? copy.all_styles : copy.all_chip }, ...activeChips].forEach(def => {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.chip = def.key;
      button.setAttribute('aria-pressed', 'false');
      button.textContent = def.label;
      chipBar.append(button);
    });
    chipBar.hidden = false;
  }

  const visibleGroups = [];
  $$('fieldset[data-group]').forEach(fieldset => {
    const key = fieldset.dataset.group;
    const counts = {};
    cards.forEach(card => (card.groups[key] || []).forEach(value => { counts[value] = (counts[value] || 0) + 1; }));
    const qualifies = Object.values(counts).filter(count => count >= 2).length >= 2;
    const allowed = key === 'pet' ? petHandles.includes(handle) : (conf.groups || []).includes(key);
    if (!hasSidebar || !allowed || !qualifies) { fieldset.remove(); return; }
    const select = fieldset.querySelector('select');
    groupOrder[key].filter(value => counts[value]).forEach(value => {
      const option = document.createElement('option');
      option.value = value;
      option.dataset.label = groupLabels[key](value);
      option.textContent = option.dataset.label + ' (' + counts[value] + ')';
      select.append(option);
    });
    fieldset.hidden = false;
    visibleGroups.push(key);
  });
  const priceGroup = $('[data-price-group]');
  if (priceGroup) priceGroup.hidden = !(conf.groups || []).includes('price');

  const state = { chip: '', kinds: [], filters: {}, min: 0, max: Infinity, hasMin: false, hasMax: false };
  const minInput = $('#br-min');
  const maxInput = $('#br-max');
  const params = new URL(location.href).searchParams;
  state.chip = activeChips.some(def => def.key === params.get('br_chip')) ? params.get('br_chip') : '';
  const samePriceCurrency = !params.has('br_currency') || params.get('br_currency') === currency;
  if (minInput && maxInput) ['min', 'max'].forEach(key => {
    const value = params.get('br_' + key);
    if (samePriceCurrency && value !== null && value !== '' && Number.isFinite(Number(value)) && Number(value) >= 0) $('#br-' + key).value = value;
  });
  $$('input[data-kind]').forEach(input => { input.checked = (params.get('br_kind') || '').split(',').includes(input.value); });
  const filterSelects = $$('select[data-filter]');
  filterSelects.forEach(select => {
    const wanted = params.get('br_' + select.dataset.filter);
    if ([...select.options].some(option => option.value === wanted)) select.value = wanted;
  });
  $$('[data-kind-count]').forEach(element => {
    const count = cards.filter(card => card.kind === element.dataset.kindCount).length;
    element.textContent = '(' + count + ')';
    element.closest('[data-kind-label]').hidden = count === 0;
  });
  const nativeSort = root.dataset.nativeSort;
  const sort = $('[data-sort]');
  if (sort && [...sort.options].some(option => option.value === nativeSort)) sort.value = nativeSort;
  const readRange = () => {
    if (!minInput || !maxInput || priceGroup?.hidden) return { min: 0, max: Infinity, hasMin: false, hasMax: false };
    const hasMin = minInput.value.trim() !== '';
    const hasMax = maxInput.value.trim() !== '';
    const min = hasMin ? Number(minInput.value) : 0;
    const max = hasMax ? Number(maxInput.value) : Infinity;
    let error = '';
    if (minInput.validity.badInput || maxInput.validity.badInput || !Number.isFinite(min) || (hasMax && !Number.isFinite(max))) error = message('range_invalid');
    else if (min < 0 || max < 0) error = message('range_negative');
    else if (min > max) error = message('range_reversed');
    $('#br-price-error').textContent = error;
    minInput.setAttribute('aria-invalid', String(Boolean(error)));
    maxInput.setAttribute('aria-invalid', String(Boolean(error)));
    return error ? null : { min, max, hasMin, hasMax };
  };
  const updateUrl = () => {
    const url = new URL(location.href);
    const fields = { chip: state.chip, kind: state.kinds.join(','), min: state.hasMin ? String(state.min) : '', max: state.hasMax ? String(state.max) : '' };
    filterSelects.forEach(select => { fields[select.dataset.filter] = state.filters[select.dataset.filter] || ''; });
    Object.entries(fields).forEach(([key, value]) => value === '' ? url.searchParams.delete('br_' + key) : url.searchParams.set('br_' + key, value));
    if (state.hasMin || state.hasMax) url.searchParams.set('br_currency', currency);
    else url.searchParams.delete('br_currency');
    history.replaceState(history.state, '', url);
  };
  const chipsBox = $('[data-chips]');
  const chip = (label, clear) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = label + ' ×';
    button.setAttribute('aria-label', message('remove', { filter: label }));
    button.addEventListener('click', () => { clear(); apply(); });
    chipsBox.append(button);
  };
  const render = () => {
    let count = 0;
    cards.forEach(card => {
      const visible = (!state.chip || card.chips.includes(state.chip)) &&
        (!state.kinds.length || state.kinds.includes(card.kind)) &&
        Object.entries(state.filters).every(([key, value]) => !value || (card.groups[key] || []).includes(value)) &&
        card.price >= state.min && card.price <= state.max;
      card.element.hidden = !visible;
      if (visible) count++;
    });
    $('[data-empty]').hidden = count !== 0;
    const counter = $('[data-result-count]');
    if (counter) counter.textContent = message('result_count', { count, total: cards.length });
    $$('button[data-chip]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.chip === state.chip)));
    if (!chipsBox) return;
    chipsBox.replaceChildren();
    if (state.chip) {
      const def = activeChips.find(item => item.key === state.chip);
      chip(def.label, () => { state.chip = ''; });
    }
    state.kinds.forEach(kind => {
      const input = $$('input[data-kind]').find(item => item.value === kind);
      const label = [...input.closest('label').childNodes].filter(node => node.nodeType === Node.TEXT_NODE).map(node => node.textContent).join('').trim();
      chip(label, () => { input.checked = false; });
    });
    filterSelects.forEach(select => {
      if (!select.value) return;
      const legend = select.closest('fieldset').querySelector('legend').textContent.trim();
      chip(legend + ': ' + select.selectedOptions[0].dataset.label, () => { select.value = ''; });
    });
    if (state.hasMin || state.hasMax) {
      const label = state.hasMin && state.hasMax ? money(state.min) + ' – ' + money(state.max) : state.hasMin ? message('from_only', { min: money(state.min) }) : message('up_to', { max: money(state.max) });
      chip(label, () => { minInput.value = ''; maxInput.value = ''; });
    }
    const showButton = $('[data-show-results] span');
    if (showButton) showButton.textContent = message('show_count', { count });
  };
  function apply() {
    const range = readRange();
    if (!range) return false;
    const filters = {};
    filterSelects.forEach(select => { filters[select.dataset.filter] = select.value; });
    Object.assign(state, range, { kinds: $$('input[data-kind]:checked').map(input => input.value), filters });
    render();
    updateUrl();
    return true;
  }
  const reset = () => {
    if (minInput) minInput.value = '';
    if (maxInput) maxInput.value = '';
    state.chip = '';
    $$('input[data-kind]').forEach(input => { input.checked = false; });
    filterSelects.forEach(select => { select.value = ''; });
    apply();
  };
  $$('[data-reset]').forEach(button => button.addEventListener('click', reset));
  $('[data-apply]')?.addEventListener('click', apply);
  [...$$('input[data-kind]'), ...filterSelects].forEach(input => input.addEventListener('change', apply));
  $$('button[data-chip]').forEach(button => button.addEventListener('click', () => {
    if (!readRange()) return;
    state.chip = button.dataset.chip;
    apply();
  }));
  [minInput, maxInput].filter(Boolean).forEach(input => input.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); apply(); } }));
  sort?.addEventListener('change', () => {
    if (!apply()) { sort.value = nativeSort; return; }
    const url = new URL(location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    url.hash = '';
    location.assign(url.toString());
  });

  const dialog = $('#br-filter-dialog');
  const filterContent = $('[data-filter-content]');
  const filterHome = $('.br-filter-home');
  const opener = $('[data-open-filters]');
  const mobile = matchMedia('(max-width: 800px)');
  const closeFilters = () => { if (dialog?.open) dialog.close(); restoreFilters(); };
  function restoreFilters() {
    if (!filterHome || !filterContent) return;
    filterHome.append(filterContent);
    opener?.setAttribute('aria-expanded', 'false');
    if (mobile.matches && !$('[data-collection-panel]').hidden) opener?.focus();
  }
  if (dialog && filterContent && opener) {
    opener.addEventListener('click', () => {
      $('[data-dialog-body]').append(filterContent);
      dialog.showModal();
      opener.setAttribute('aria-expanded', 'true');
      $('[data-close-filters]').focus();
    });
    $('[data-close-filters]').addEventListener('click', closeFilters);
    $('[data-show-results]')?.addEventListener('click', () => { if (apply()) closeFilters(); });
    dialog.addEventListener('close', restoreFilters);
    dialog.addEventListener('cancel', event => { event.preventDefault(); closeFilters(); });
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll('a[href], button, input, select, [tabindex]')].filter(element => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    mobile.addEventListener('change', event => { if (!event.matches && dialog.open) closeFilters(); });
  }

  const guidePanel = $('[data-guide-panel]');
  if (!guidePanel) { if (!apply()) reset(); return; }
  let guideOpener = null;
  const showPanel = (focus = true) => {
    const guide = ['#bed-finder', '#br-guide-title'].includes(location.hash);
    if (dialog?.open) closeFilters();
    $('[data-collection-panel]').hidden = guide;
    guidePanel.hidden = !guide;
    if (focus) {
      if (guide) $('#br-guide-title').focus();
      else if (guideOpener?.isConnected) guideOpener.focus();
    }
  };
  $$('[data-guide-link]').forEach(link => link.addEventListener('click', () => { guideOpener = link; }));
  addEventListener('hashchange', () => showPanel());
  $('[data-return]').addEventListener('click', () => { if (location.hash === '#br-collection') showPanel(); });
  $('[data-edit]').addEventListener('click', () => { $('#br-guide-title').focus(); });
  const val = id => $('#br-' + id).value;
  $('#br-goal').addEventListener('change', () => { $('[data-owned-wrap]').hidden = val('goal') !== 'cover'; });
  if (['US', 'LR', 'MM'].includes((root.dataset.country || '').toUpperCase())) $('#br-units').value = 'in';
  const measures = { length: null, width: null };
  const measureFactor = () => val('units') === 'in' ? 2.54 : 1;
  ['length', 'width'].forEach(key => $('#br-' + key).addEventListener('input', () => {
    const input = $('#br-' + key);
    measures[key] = input.value === '' ? null : Number(input.value) * measureFactor();
  }));
  $('#br-units').addEventListener('change', () => {
    ['length', 'width'].forEach(key => {
      if (measures[key] !== null) $('#br-' + key).value = String(Math.round(measures[key] / measureFactor() * 100) / 100);
    });
  });
  $('#br-later').addEventListener('change', event => {
    ['length', 'width'].forEach(key => { $('#br-' + key).disabled = event.target.checked; });
    $('[data-measure-error]').textContent = '';
  });
  const formatLength = cm => {
    const unit = val('units');
    const value = unit === 'in' ? Math.round(cm / 2.54 * 10) / 10 : Math.round(cm * 10) / 10;
    return value + ' ' + copy[unit];
  };
  // Kiwi size charts (cm). internal: [size, external, internal]; external: [size, length, width] with an edge/bolster allowance.
  const KIWI = {
    'calming-dog-bed-removable-cover': { basis: 'internal', sizes: [['S', 50, 30], ['M', 60, 35], ['L', 70, 45], ['XL', 80, 55], ['2XL', 100, 75], ['3XL', 110, 85]] },
    'original-calming-pet-bed': { basis: 'internal', sizes: [['S', 50, 30], ['M', 60, 35], ['L', 70, 45], ['XL', 80, 55], ['2XL', 100, 75]] },
    'calming-support-dog-bed': { basis: 'external', allowance: 15, sizes: [['S', 45, 40], ['M', 60, 48], ['L', 80, 55], ['XL', 110, 70], ['2XL', 130, 90]] },
    'luxury-boucle-supportive-dog-bed': { basis: 'external', allowance: 20, sizes: [['S', 75, 58], ['M', 94, 74], ['L', 115, 90], ['XL', 155, 110]] },
    'plush-orthopaedic-calming-bed-v2-0': { basis: 'external', allowance: 5, sizes: [['S', 40, 30], ['M', 50, 40], ['L', 75, 50], ['XL', 100, 60], ['2XL', 120, 80]] }
  };
  const recommendSize = (card, length) => {
    const chart = KIWI[card.handle];
    if (!chart) return { status: 'none' };
    if (length === null) return { status: 'measure' };
    const needed = length * 1.1;
    const offered = card.sizes.length ? chart.sizes.filter(([size]) => card.sizes.includes(size)) : chart.sizes;
    for (const [size, outer, inner] of offered) {
      const usable = chart.basis === 'internal' ? inner : outer - chart.allowance;
      if (usable >= needed) return { status: 'fit', size, outer, usable, basis: chart.basis, allowance: chart.allowance || 0 };
    }
    return { status: 'too_small' };
  };
  const handles = {
    boucle: 'luxury-boucle-supportive-dog-bed',
    ultimate: 'plush-orthopaedic-calming-bed-v2-0',
    calming: 'calming-dog-bed-removable-cover',
    support: 'calming-support-dog-bed',
    classic: 'original-calming-pet-bed',
    outdoor: 'fold-go-outdoor-pet-bed',
    sofa: 'luxury-sofa-dog-bed',
    cover: 'ultimate-comfort-calming-dog-bed-replacement-cover'
  };
  const guideCandidates = Object.entries(handles).map(([key, productHandle], rank) => ({ key, rank, card: cards.find(card => card.handle === productHandle) })).filter(candidate => candidate.card);
  const fitsOuter = (a, length, width) => a.length === null || (a.length <= length && a.width <= width) || (a.length <= width && a.width <= length);
  const SCORES = {
    look: { boucle: { boucle: 4 }, plush: { ultimate: 4, calming: 4, support: 3, classic: 3 }, versatile: { sofa: 4 } },
    sleep: { curl: { calming: 3, classic: 3, sofa: 2 }, stretch: { ultimate: 2, support: 2, boucle: 1 }, head: { boucle: 3, support: 2 }, mixed: { sofa: 3 } }
  };
  const score = (candidate, answer) => (SCORES.look[answer.look]?.[candidate.key] || 0) + (SCORES.sleep[answer.sleep]?.[candidate.key] || 0);
  const shortlist = answer => {
    if (answer.goal === 'cover') return answer.owned === 'ultimate' ? guideCandidates.filter(candidate => candidate.key === 'cover') : [];
    return guideCandidates.filter(candidate => {
      if (candidate.key === 'cover') return false;
      if (answer.place === 'outdoor' && candidate.key !== 'outdoor') return false;
      if (answer.place === 'indoor' && candidate.key === 'outdoor') return false;
      if (answer.wash === 'must' && !['boucle', 'ultimate', 'calming', 'classic'].includes(candidate.key)) return false;
      if (candidate.key === 'outdoor' && !fitsOuter(answer, 70, 70)) return false;
      candidate.fit = recommendSize(candidate.card, answer.length);
      if (candidate.fit.status === 'too_small') return false;
      return true;
    }).sort((a, b) => score(b, answer) - score(a, answer) || a.rank - b.rank).slice(0, 3);
  };
  $('[data-guide-form]').addEventListener('submit', event => {
    event.preventDefault();
    const later = $('#br-later').checked;
    const answer = { goal: val('goal'), owned: val('owned'), sleep: val('sleep'), place: val('place'), wash: val('wash'), look: val('look'), length: later ? null : measures.length, width: later ? null : measures.width };
    const invalidMeasure = !later && ['length', 'width'].some(key => !Number.isFinite(answer[key]) || answer[key] <= 0 || answer[key] > 500 || $('#br-' + key).validity.badInput);
    const budgetInput = $('#br-budget');
    const hasBudget = budgetInput.value.trim() !== '';
    const budget = hasBudget ? Number(budgetInput.value) : null;
    const invalidBudget = budgetInput.validity.badInput || (hasBudget && (!Number.isFinite(budget) || budget < 0));
    $('[data-measure-error]').textContent = invalidMeasure ? message('measure_invalid') : '';
    $('[data-budget-error]').textContent = invalidBudget ? message('budget_invalid') : '';
    ['length', 'width'].forEach(key => $('#br-' + key).setAttribute('aria-invalid', String(invalidMeasure)));
    budgetInput.setAttribute('aria-invalid', String(invalidBudget));
    if (invalidMeasure) { $('#br-length').focus(); return; }
    if (invalidBudget) { budgetInput.focus(); return; }
    const results = shortlist(answer);
    $('[data-guide-summary]').textContent = message(answer.goal === 'cover' ? 'guide_intro_cover' : 'guide_intro_bed');
    const measured = later ? message('measure_unset') : message('footprint', { length: formatLength(answer.length), width: formatLength(answer.width) });
    $('[data-guide-caution]').textContent = measured + (hasBudget ? ' ' + message('budget_record', { amount: money(budget) }) : '');
    const container = $('[data-guide-cards]');
    container.replaceChildren();
    results.forEach((candidate, index) => {
      const card = candidate.card.element.cloneNode(true);
      card.hidden = false;
      card.removeAttribute('data-product-card');
      card.querySelector('[data-product-options]')?.remove();
      card.querySelector('.br-kind-label')?.remove();
      card.querySelector('.br-card-meta')?.remove();
      const candidateLabel = document.createElement('p');
      candidateLabel.className = 'br-kind-label body3';
      candidateLabel.textContent = message(candidate.key === 'cover' ? 'cover_candidate' : index === 0 ? 'primary' : 'candidate');
      card.prepend(candidateLabel);
      const reason = document.createElement('p');
      reason.className = 'br-card-meta body3';
      const split = candidate.card.element.querySelector('.br-price-split')?.textContent.trim();
      reason.textContent = message('why_' + candidate.key) + (split ? ' ' + split : '');
      card.append(reason);
      card.querySelectorAll('.price, .unit-price, quick-add-modal, modal-opener, product-form').forEach(element => element.remove());
      card.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
      const fit = candidate.key === 'cover' ? { status: 'cover' } : (candidate.fit || recommendSize(candidate.card, answer.length));
      const note = document.createElement('p');
      note.className = 'br-small';
      if (fit.status === 'fit') {
        note.classList.add('br-size-rec');
        const strong = document.createElement('strong');
        strong.textContent = message('kiwi_size', { size: fit.size });
        note.append(strong, document.createTextNode(message(fit.basis === 'internal' ? 'kiwi_internal' : 'kiwi_external', { size: fit.size, usable: formatLength(fit.usable), outer: formatLength(fit.outer), allowance: formatLength(fit.allowance), length: formatLength(answer.length) })));
      } else {
        note.textContent = message(fit.status === 'cover' ? 'outer_cover' : fit.status === 'measure' ? 'kiwi_measure' : 'kiwi_none');
      }
      card.append(note);
      const detailLink = document.createElement('a');
      detailLink.className = 'btn btn_zoom btn--add-to-cart br-cta br-card-cta';
      detailLink.href = card.querySelector('.product-card__heading')?.href || (((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + candidate.card.handle);
      const detailText = document.createElement('span');
      detailText.textContent = message('details_size') + ' ↗';
      detailLink.append(detailText);
      card.append(detailLink);
      container.append(card);
    });
    if (!results.length) {
      const empty = document.createElement('div');
      empty.className = 'br-empty';
      const heading = document.createElement('h3');
      heading.textContent = message('no_match');
      const explanation = document.createElement('p');
      explanation.textContent = message('no_match_help');
      empty.append(heading, explanation);
      container.append(empty);
    }
    $('[data-guide-results]').hidden = false;
    $('#br-result-title').focus();
    $('#br-result-title').scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
  if (!apply()) reset();
  showPanel(false);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      if(document.getElementById('SortBy')){
        document.getElementById('SortBy').value = event.target.dataset.value;
        document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
      }
      else{
        document.getElementById('SortBy-mobile').value = event.target.dataset.value;
        document.getElementById('FacetFiltersFormMobile').dispatchEvent(new Event('input'));
      }
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    }

    if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      document.getElementById('SortBy').value = event.target.dataset.value;
      document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
function initializeEvergreenHeroes() {
  customElements.whenDefined('big-slider').then(() => {
    document.querySelectorAll('big-slider[data-evergreen-artwork]').forEach((slider) => {
      if (slider.dataset.controlsReady) return;
      slider.dataset.controlsReady = 'true';
      const slides = Array.from(slider.querySelectorAll('.slideshow'));
      const dots = Array.from(slider.querySelectorAll('.big-slider__dots__item'));
      const pause = slider.querySelector('.buddies-hero-pause');
      let paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let hovering = false;
      const startAutoplay = slider.startAutoplay.bind(slider);
      slider.startAutoplay = () => {
        clearTimeout(slider.slider);
        if (!paused && !hovering && !document.hidden && slider.slider_time) startAutoplay();
      };
      const updateControls = () => {
        if (pause) {
          pause.setAttribute('aria-label', paused ? pause.dataset.play : pause.dataset.pause);
          pause.setAttribute('aria-pressed', String(paused));
        }
        slides.forEach((slide, index) => {
          const active = slide.classList.contains('active');
          slide.setAttribute('aria-hidden', String(!active));
          slide.tabIndex = active ? 0 : -1;
          dots[index].setAttribute('aria-current', String(active));
        });
      };
      dots.forEach((dot) => {
        dot.addEventListener('click', (event) => event.stopPropagation());
        dot.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          event.stopPropagation();
          slider.dotsClick({ target: dot });
        });
      });
      if (pause) pause.addEventListener('click', (event) => {
        event.stopPropagation();
        paused = !paused;
        updateControls();
        slider.startAutoplay();
      });
      slider.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        hovering = true;
        slider.startAutoplay();
      });
      slider.addEventListener('pointerleave', () => {
        hovering = false;
        slider.startAutoplay();
      });
      slider.addEventListener('focusin', (event) => {
        if (event.target === pause) return;
        paused = true;
        updateControls();
        slider.startAutoplay();
      });
      document.addEventListener('visibilitychange', () => slider.startAutoplay());
      const observer = new MutationObserver(updateControls);
      slides.forEach((slide) => observer.observe(slide, { attributes: true, attributeFilter: ['class'] }));
      updateControls();
      slider.startAutoplay();
    });
  });
}
initializeEvergreenHeroes();
document.addEventListener('shopify:section:load', initializeEvergreenHeroes);

  } catch(e) { console.error(e); }
})();
})();
